import React from "react";
import styled from "@emotion/styled";
import {
  Box,
  CompassColor,
  Button,
  VariantColor,
  Variant,
} from "@noom/wax-component-library";

import { sendBuyflowExit, sendWebviewExit } from "../utils/nativeNavigation";

const InfoTileContainer = styled.div`
  margin-bottom: 16px;
  width: 100%;
  padding: 24px;
  background-color: ${CompassColor.white};
  border: 1px solid ${CompassColor.sand01};
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: "Untitled Sans", sans-serif;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
`;

const Description = styled.p`
  margin: 8px 0 0 0;
  font-size: 14px;
  color: ${CompassColor.grey2};
  max-width: 400px;
`;

const ContentWrapper = styled.div`
  flex: 1;
`;

export const NativeDemoPage: React.FC = () => {
  const handleBuyflowExit = () => {
    sendBuyflowExit();
  };

  const handleBuyflowExitWithToast = () => {
    const toastPayload = { toast: "Buyflow exited successfully!" };
    sendBuyflowExit(toastPayload);
  };

  const handleWebviewExit = () => {
    sendWebviewExit();
  };

  const handleWebviewExitWithToast = () => {
    const toastPayload = { toast: "Webview exited successfully!" };
    sendWebviewExit(toastPayload);
  };

  const handleRedirectWithToast = () => {
    const message = "This is a toast";
    const encodedMessage = encodeURIComponent(message);
    window.location.href = `/shipping-and-refills?close=1&toast=${encodedMessage}`;
  };

  return (
    <Box padding="24px" maxWidth="800px" margin="0 auto">
      <h1 style={{ textAlign: "center", marginBottom: "32px" }}>
        Native Demo Page
      </h1>

      <InfoTileContainer>
        <ContentWrapper>
          <Title>Buyflow Exit (No Parameters)</Title>
          <Description>
            Sends a buyflowExit message to the native app with no additional parameters.
          </Description>
        </ContentWrapper>
        <Button
          variant={Variant.outline}
          variantColor={VariantColor.secondary}
          color={CompassColor.black}
          size="sm"
          onClick={handleBuyflowExit}
        >
          Exit Buyflow
        </Button>
      </InfoTileContainer>

      <InfoTileContainer>
        <ContentWrapper>
          <Title>Buyflow Exit (With Toast)</Title>
          <Description>
            Sends a buyflowExit message to the native app with a toast parameter containing a message to display.
          </Description>
        </ContentWrapper>
        <Button
          variant={Variant.outline}
          variantColor={VariantColor.secondary}
          color={CompassColor.black}
          size="sm"
          onClick={handleBuyflowExitWithToast}
        >
          Exit with Toast
        </Button>
      </InfoTileContainer>

      <InfoTileContainer>
        <ContentWrapper>
          <Title>Webview Exit (No Parameters)</Title>
          <Description>
            Sends a webviewExit message to the native app with no additional parameters.
          </Description>
        </ContentWrapper>
        <Button
          variant={Variant.outline}
          variantColor={VariantColor.secondary}
          color={CompassColor.black}
          size="sm"
          onClick={handleWebviewExit}
        >
          Exit Webview
        </Button>
      </InfoTileContainer>

      <InfoTileContainer>
        <ContentWrapper>
          <Title>Webview Exit (With Toast)</Title>
          <Description>
            Sends a webviewExit message to the native app with a toast parameter containing a message to display.
          </Description>
        </ContentWrapper>
        <Button
          variant={Variant.outline}
          variantColor={VariantColor.secondary}
          color={CompassColor.black}
          size="sm"
          onClick={handleWebviewExitWithToast}
        >
          Exit with Toast
        </Button>
      </InfoTileContainer>

      <InfoTileContainer>
        <ContentWrapper>
          <Title>Redirect with Toast</Title>
          <Description>
            Redirects to the shipping and refills page with close=1 and toast query parameters.
          </Description>
        </ContentWrapper>
        <Button
          variant={Variant.outline}
          variantColor={VariantColor.secondary}
          color={CompassColor.black}
          size="sm"
          onClick={handleRedirectWithToast}
        >
          Redirect with Toast
        </Button>
      </InfoTileContainer>
    </Box>
  );
};
